<template>
  <div class="container pb-20 pt-60 md:pt-80">
    <!-- Details -->
    <div class="grid grid-cols-1 gap-20 xl:grid-cols-content">
      <!-- Intro -->
      <div class="content-start">
        <PrismicImage
          v-if="page"
          class="object-cover"
          :field="page?.data.featured_image"
        />
        <caption class="my-[8px] block text-left">
          {{ page?.data.featured_image.alt }}
        </caption>

        <h1 class="my-10 text-header1 md:text-desktop-header1">
          {{ page?.data.title }}
        </h1>
        <h2 class="mb-10 text-header2 md:text-desktop-header2">
          {{ page?.data.sub_title }}
        </h2>
        <PrismicRichText
          :field="page?.data.description"
          class="text-large-copy md:text-desktop-large-copy"
        />

        <!-- Slices -->
        <SliceZone
          wrapper="main"
          :slices="page?.data.slices ?? []"
          :components="components"
        />
      </div>

      <!-- Bar -->
      <div class="sticky top-40 mt-4 h-80">
        <div class="content-start">
          <UIShare :metadata="page?.data" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { components } from "~/slices";

const prismic = usePrismic();
const route = useRoute();
const config = useRuntimeConfig();

const { data: page } = await useAsyncData(route.params.uid as string, async () =>
  prismic.client.getByUID("articles", route.params.uid as string),
);

if (!page.value) {
  throw createError({ statusCode: 404 });
}

useSeoMeta({
  description: () => page.value?.data.meta_description?.length ? page.value.data.meta_description : prismic.asText(page.value?.data.description),
  ogTitle: () => page.value?.data.meta_title?.length ? page.value.data.meta_title : page.value?.data.title,
  ogUrl: () => `${config.public.BASE_URL}${route.fullPath}`,
  ogDescription: () => page.value?.data.meta_description?.length ? page.value.data.meta_description : prismic.asText(page.value?.data.description),
  ogImage: () => page.value?.data.meta_image.url?.length ? page.value.data.meta_image.url : `${config.public.BASE_URL}/lightbox_gallery.jpg`,
  ogImageType: () => "image/jpeg",
  ogImageWidth: () => "1200",
  ogImageHeight: () => "630",
  ogType: () => "website",
  twitterTitle: () => page.value?.data.meta_title?.length ? page.value.data.meta_title : page.value?.data.title,
  twitterImage: () => page.value?.data.meta_image.url?.length ? page.value.data.meta_image.url : `${config.public.BASE_URL}/lightbox_gallery.jpg`,
  twitterDescription: () => page.value?.data.meta_description?.length ? page.value.data.meta_description : prismic.asText(page.value?.data.description),
});
</script>
